import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/admin/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Evangelism from "@/pages/Evangelism";
import Departments from "@/pages/Departments";
import Leadership from "@/pages/Leadership";
import Church from "@/pages/Church";
import { MediaListPage } from "@/pages/MediaListPage";
import PrayerRequests from "@/pages/PrayerRequests";
import Giving from "@/pages/Giving";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import Login from "@/admin/Login";
import AdminApp from "@/admin/AdminApp";

const PublicSite = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/evangelism" element={<Evangelism />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/leadership" element={<Leadership />} />
      <Route path="/tabernacle-of-grace" element={<Church />} />
      <Route path="/sermons" element={<MediaListPage type="sermons" />} />
      <Route path="/podcasts" element={<MediaListPage type="podcasts" />} />
      <Route path="/videos" element={<MediaListPage type="videos" />} />
      <Route path="/gallery" element={<MediaListPage type="gallery" />} />
      <Route path="/events" element={<MediaListPage type="events" />} />
      <Route path="/announcements" element={<MediaListPage type="announcements" />} />
      <Route path="/prayer-requests" element={<PrayerRequests />} />
      <Route path="/giving" element={<Giving />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={<ProtectedRoute><AdminApp /></ProtectedRoute>} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
